let obj = {};
obj.companyIdTypeOptions = [
    // {
    //     value: "01",
    //     name: "组织机构代码证",
    // },
    {
        value: "04",
        name: "统一社会信用代码"
    },
    // {
    //     value: "02",
    //     name: "税务登记证"
    // },
    // {
    //     value: "03",
    //     name: "其他",
    // },
]
obj.plansValues = [
    {
        name: '计划一',
        value: '04014B-P04014B01',
        money1: '50万',
        money2: '50万',
        premium: '800'
    },
    {
        name: '计划二',
        value: '04014B-P04014B02',
        money1: '100万',
        money2: '50万',
        premium: '1200'
    },
    {
        name: '计划三',
        value: '04014B-P04014B03',
        money1: '150万',
        money2: '50万',
        premium: '1750'
    },
    {
        name: '计划四',
        value: '04014B-P04014B04',
        money1: '200万',
        money2: '50万',
        premium: '2000'
    },
    {
        name: '计划五',
        value: '04014B-P04014B05',
        money1: '300万',
        money2: '50万',
        premium: '3350'
    },
    {
        name: '计划六',
        value: '04014B-P04014B06',
        money1: '400万',
        money2: '50万',
        premium: '3850'
    },
    {
        name: '计划七',
        value: '04014B-P04014B07',
        money1: '500万',
        money2: '100万',
        premium: '5050'
    },
    {
        name: '计划八',
        value: '04014B-P04014B08',
        money1: '600万',
        money2: '100万',
        premium: '5200'
    },
    {
        name: '计划九',
        value: '04014B-P04014B09',
        money1: '800万',
        money2: '100万',
        premium: '5400'
    },
    {
        name: '计划十',
        value: '04014B-P04014B10',
        money1: '1000万',
        money2: '100万',
        premium: '5600'
    },
    {
        name: '计划一',
        value: '04014C-P04014C01',
        money1: '50万',
        money2: '50万',
        premium: '1300'
    },
    {
        name: '计划二',
        value: '04014C-P04014C02',
        money1: '100万',
        money2: '50万',
        premium: '1700'
    },
    {
        name: '计划三',
        value: '04014C-P04014C03',
        money1: '150万',
        money2: '50万',
        premium: '2250'
    },
    {
        name: '计划四',
        value: '04014C-P04014C04',
        money1: '200万',
        money2: '50万',
        premium: '2500'
    },
    {
        name: '计划五',
        value: '04014C-P04014C05',
        money1: '300万',
        money2: '50万',
        premium: '3850'
    },
    {
        name: '计划六',
        value: '04014C-P04014C06',
        money1: '400万',
        money2: '50万',
        premium: '4350'
    },
    {
        name: '计划七',
        value: '04014C-P04014C07',
        money1: '500万',
        money2: '100万',
        premium: '5550'
    },
    {
        name: '计划八',
        value: '04014C-P04014C08',
        money1: '600万',
        money2: '100万',
        premium: '5700'
    },
    {
        name: '计划九',
        value: '04014C-P04014C09',
        money1: '800万',
        money2: '100万',
        premium: '5900'
    },
    {
        name: '计划十',
        value: '04014C-P04014C10',
        money1: '1000万',
        money2: '100万',
        premium: '6100'
    }
]
//企业类型
obj.industryType = [
    {
        name: '农业',
        value: '01',
    },
    {
        name: '家具制造业',
        value: '21',
    },
    {
        name: '医药制造业',
        value: '27',
    },
    {
        name: '化学纤维制造业',
        value: '28',
    },
    {
        name: '建筑安装业',
        value: '48',
    },
    {
        name: '体育',
        value: '91',
    },
    {
        name: '群众团体、社会团体和宗教组织',
        value: '96',
    }
]
export default { ...obj }